//@ts-nocheck
import React, { ReactElement, useRef } from 'react';

import { Box } from 'components';

import FullscreenContext from './Context';
import useFullscreen from './useFullscreen';
import { IFullscreenProps } from './types';

const Provider = ({ children, ...props }: IFullscreenProps): ReactElement => {
  let fullscreenRef = useRef(null);

  let isFullscreen = false;
  let enableFullscreen = () => {
    /**/
  };
  let disableFullscreen = () => {
    /**/
  };
  let toggleFullscreen = () => {
    /**/
  };
  let errorMessage = '';

  try {
    [isFullscreen, enableFullscreen, disableFullscreen, toggleFullscreen, fullscreenRef] =
      useFullscreen();
  } catch (e) {
    errorMessage = 'O recurso de fullscreen não é suportado.';
  }

  return (
    <FullscreenContext.Provider
      value={{
        isFullscreen,
        enableFullscreen,
        disableFullscreen,
        toggleFullscreen,
        errorMessage,
        fullscreenRef,
      }}
    >
      <Box {...props} ref={fullscreenRef}>
        {children}
      </Box>
    </FullscreenContext.Provider>
  );
};

export default Provider;
